import $ from "jquery";

window.InitializeSelectAllCheckboxes = function () {
    $('input[type="checkbox"][data-selectallcontainer]').each(function (this: HTMLElement) {
        const selectAllBox = this as HTMLInputElement;
        const submitButtonId = $(selectAllBox).data("selectallsubmit") as string;
        const checkboxChildrenContainerId = $(selectAllBox).data("selectallcontainer") as string;
        const checkboxChildren = $(checkboxChildrenContainerId).find(
            'input[type="checkbox"]'
        ) as JQuery<HTMLInputElement>;
        const submitButton = $(submitButtonId);

        $(selectAllBox).on("click", function () {
            checkboxChildren.each(function (this: HTMLInputElement) {
                this.checked = selectAllBox.checked;
                if (this.checked) submitButton.prop("disabled", false);
                else submitButton.prop("disabled", true);
            });
        });

        const setSelectAllBoxState = function () {
            const numChecked = checkboxChildren.filter(":checked").length;
            if (numChecked === checkboxChildren.length) {
                selectAllBox.checked = true;
                selectAllBox.indeterminate = false;
                submitButton.prop("disabled", false);
            } else if (numChecked === 0) {
                selectAllBox.checked = false;
                selectAllBox.indeterminate = false;
                submitButton.prop("disabled", true);
            } else {
                selectAllBox.checked = false;
                selectAllBox.indeterminate = true;
                submitButton.prop("disabled", false);
            }
        };

        checkboxChildren.on("change", setSelectAllBoxState);
        setSelectAllBoxState();
    });
};

$(window.InitializeSelectAllCheckboxes);

export {};
